/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModContracts: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M8 -0.000244141V4.00076H12L8 -0.000244141Z' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 12.5C7 10.015 9.015 7.99996 11.5 7.99996C11.6273 7.99996 11.7503 8.01688 11.8734 8.03381C11.9195 8.04016 11.9656 8.0465 12.012 8.05196L12 4.99996H7V-4.41406e-05H1C0.447 -4.41406e-05 0 0.446956 0 0.999956V15C0 15.553 0.447 16 1 16H8.703C7.673 15.176 7 13.923 7 12.5ZM6.5 9.99996H2.5C2.224 9.99996 2 9.77596 2 9.49996C2 9.22396 2.224 8.99996 2.5 8.99996H6.5C6.776 8.99996 7 9.22396 7 9.49996C7 9.77596 6.776 9.99996 6.5 9.99996ZM5 12H2.5C2.224 12 2 11.776 2 11.5C2 11.224 2.224 11 2.5 11H5C5.276 11 5.5 11.224 5.5 11.5C5.5 11.776 5.276 12 5 12ZM2.5 6.99996H9.5C9.776 6.99996 10 7.22396 10 7.49996C10 7.77596 9.776 7.99996 9.5 7.99996H2.5C2.224 7.99996 2 7.77596 2 7.49996C2 7.22396 2.224 6.99996 2.5 6.99996Z'
			/>
			<path d='M13.6465 10.3135C13.8415 10.1185 14.1585 10.1185 14.3535 10.3135C14.5485 10.5085 14.5485 10.8255 14.3535 11.0205L11.0205 14.3535C10.9225 14.4515 10.7945 14.5005 10.6665 14.5005C10.5395 14.5005 10.4115 14.4515 10.3135 14.3535L8.6465 12.6865C8.4515 12.4915 8.4515 12.1745 8.6465 11.9795C8.8415 11.7845 9.1585 11.7845 9.3535 11.9795L10.6665 13.2925L13.6465 10.3135Z' />
		</Svg>
	);
};

export { ModContracts };
